<template>
  <ib-card
    class="ib-card-empty-state d-flex flex-column justify-content-center align-items-center text-center"
    :animation="false"
  >
    <v-img
      contain
      :src="icon"
      class="card-icon"
      alt="icon"
      :height="65"
    />
    <span class="card-title font-outfit-light">
      {{ title }}
    </span>
    <span class="card-description font-outfit-light">
      {{ description }}
    </span>
    <ib-button
      variant="blue"
      font-family="medium"
      :to="to"
    >
      {{ buttonText }}
    </ib-button>
  </ib-card>
</template>

<script>
export default {
  name: 'IbCardEmptyState',

  props: {
    icon: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    buttonText: {
      type: String,
      required: true
    },
    to: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">

.ib-card-empty-state {
  padding: 20px 20px;

  @include media-breakpoint-up($xl) {
    padding: 44px 88px;
  }

  .card-icon {
    margin-bottom: 32px;
  }

  .card-title {
    color: $color-font;
    font-size: 24px;
  }

  .card-description {
    color: rgba(8, 30, 74, 0.60);
    font-size: 18px;
    margin: 10px 0 25px;
  }
}
</style>
